import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-confirmation-message',
  templateUrl: './confirmation-message.fragment.html',
  styleUrls: [
    './confirmation-message.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class ConfirmationMessageFragment implements OnInit {

  public header: string = '';
  public msg: string = '';
  public list: string[] = [];

  @Output() public closeEmitter = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  public clickOuside(): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }
    this.closeConfirmationModal();
  }

  public closeConfirmationModal(): void {
    this.closeEmitter.emit(false);
  }

  public confirmAction() {
    this.closeEmitter.emit(true);
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }
}
